module.exports = __webpack_public_path__ + "img/mr.44009b41.svg";